import { AnimationBaseController, IAnimationControllerConfiguration, Inject } from '@denishussar/html5-game-engine';
import { BussinesTripMarkerModel } from '../Models/BussinesTripMarkerModel';
import { BussinesTripMarkerButtonController } from './BussinesTripMarkerButtonController';

export interface IBussinesTripMarkerControllerOptions {
    name: string;
    onSelected: (name: string) => void;
}

export class BussinesTripMarkerController extends AnimationBaseController {
    $model: BussinesTripMarkerModel;

    public constructor(@Inject private _options: IBussinesTripMarkerControllerOptions) {
        super(_options.name);
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {};
    }

    protected onInitialize(): void {
        this.addChildController({
            instanceName: this._options.name,
            view: BussinesTripMarkerButtonController,
            model: this.$model,
            options: this._options,
        }, this._options.name);
    }
}
